import { AggregateWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Aggregate')
export class AggregateNodeConnectorProvider extends ConnectorProvider<AggregateWorkflowNode> {}
